export { default } from './FocusTrap';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Unstable_TrapFocus/index.js
// module id = 840
// module chunks = 22